import { AccountType } from "component-library";

import config from "config/global";

export const DEFAULT_LOCALE = "en-GB";

export const SCROLLING_CONTAINER_ID = "body";

// ========================== Routes ==========================

export const BASE_PATH = "/jobs";

export const AGENT_SEARCH_PATH = "performers/search";

export const AGENT_SEARCH_PARAM = ":searchTerm";

export const AGENT_SEARCH_FULL_PATH = `${BASE_PATH}/${AGENT_SEARCH_PATH}/${AGENT_SEARCH_PARAM}`;

export const JOBS_PAGE_PATH = `:tab`;

export const MY_FILTERS_PATH = "matching-my-filters";

export const MY_FILTERS_FULL_PATH = `${BASE_PATH}/${MY_FILTERS_PATH}`;

export const ALL_PAID_PATH = "all-paid";

export const ALL_PAID_FULL_PATH = `${BASE_PATH}/${ALL_PAID_PATH}`;

export const ALL_OPPORTUNITIES_PATH = "all-opportunities";

export const ALL_OPPORTUNITIES_FULL_PATH = `${BASE_PATH}/${ALL_OPPORTUNITIES_PATH}`;

export const CLIENT_ALERTS_PATH = "client-alerts";

export const MY_SUGGESTIONS_PATH = "my-suggestions";

export const SELF_TAPE_PATH = "self-tape-requests";

export const SELF_TAPE_FULL_PATH = `${BASE_PATH}/${SELF_TAPE_PATH}`;

export const SELF_TAPER_DETAIL_PATH = `${SELF_TAPE_PATH}/:performerRequestId`;

export const SELF_TAPE_DETAIL_FULL_PATH = `${BASE_PATH}/${SELF_TAPER_DETAIL_PATH}`;

export const SELF_TAPE_UPLOAD_PATH = `upload`;

export const SELF_TAPE_UPLOAD_FULL_PATH = `${SELF_TAPE_DETAIL_FULL_PATH}/${SELF_TAPE_UPLOAD_PATH}`;

export const BREAKDOWN_PATH = "breakdowns";

export const BREAKDOWN_ID = ":breakdownId";

export const BREAKDOWN_FULL_PATH = `${BASE_PATH}/${BREAKDOWN_PATH}/${BREAKDOWN_ID}`;

export const BREAKDOWN_PRINT_PATH = "print";

export const BREAKDOWN_PRINT_FULL_PATH = `${BREAKDOWN_FULL_PATH}/${BREAKDOWN_PRINT_PATH}`;

export const ROLE_PATH = "role/:roleId";

export const ROLE_FULL_PATH = `${BREAKDOWN_FULL_PATH}/${ROLE_PATH}`;

export const FOLLOW_UP_PATH = "follow-up-message/:followUpId";

export const FOLLOW_UP_FULL_PATH = `${BREAKDOWN_FULL_PATH}/${FOLLOW_UP_PATH}`;

// ========================== Routes ==========================

export const PAGINATION_PAGE_RANGE_MOBILE = 2;

export const PAGINATION_PAGE_RANGE_DESKTOP = 7;

export const DEFAULT_CLIENT_AGENCY_ID = 50;

export const NO_CLIENT_AGENCY_ID = -1;

export const JOB_UPDATE_NAVIGATION_DELAY = 2000;

export const ONE_DAY = 1000 * 60 * 60 * 24;

export const USE_BROWSER_BACK_KEY = "useBrowserBack";

export enum ErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  UnprocessableEntity = 422,
  InternalServerError = 500,
}

export const ACCOUNT_TYPE_GTM_MAPPING = {
  [AccountType.Agent]: config.gtm.accountTypes.agent,
  [AccountType.Performer]: config.gtm.accountTypes.performer,
};

export enum ErrorPopupType {
  System = "systemError",
  Account = "accountError",
  Access = "accountAccessError",
  Network = "networkError",
}

export enum PageTitleKey {
  JobsFeedMatchingMySettings = "jobsFeedMatchingMySettings",
  JobsFeedAllOpportunities = "jobsFeedAllOpportunities",
  JobsFeedProjects = "jobsFeedProjects",
  JobsFeedAllPaid = "jobsFeedAllPaid",
  JobsFeedSelfTapeRequests = "jobsFeedSelfTapeRequests",
  FollowUp = "followUp",
  Breakdown = "breakdown",
  Role = "role",
  SelfTapeAddVideo = "selfTapeAddVideo",
  SelfTapeRequest = "selfTapeRequest",
  AgentQuickSearch = "agentQuickSearch",
}
